module.exports = __webpack_public_path__ + "static/forecast/weather/nightpartcloud-b28b11aab0d14efb990c447eab7df36b.svg";